import React, { useEffect, useState } from "react";
import { Get } from "../../../../../Request";
import { sepJustMoney } from "../../../Function";
import { BsExclamationDiamond, BsRecord2 } from "react-icons/bs";
import { toast } from "react-hot-toast";
import CustomModal from "../../Modal/CustomModal";
import { FormControlLabel, FormGroup, Switch, TextField } from "@mui/material";


const TicketList = ({ ticketData, role, updateAll, setUpdateAll, isAbsent, appModal }) => {
    const [refundList, setRefundList] = useState();
    const [modal, setModal] = useState(false);
    const [reason, setReason] = useState();
    const [wage, setWage] = useState(false);

    useEffect(() => {
        Get({ url: "/refundsetting/getall", data: { item_id: ticketData[0].item_id } }).then(data => {
            setRefundList(data)
        });
    }, []);

    const Renderststus = type => {
        switch (type) {
            case "used":
                return "منقضی شده";
            case "refund":
                return "استرداد شده";
            case "canceled":
                return "لغو شده";
            default:
                return "عدم پرداخت";
        }
    };

    const refundTicket = async (ticketId) => {

        let refundData = { reserve_id: ticketId };
        let isDelete = false;

        if (role == "owner") {
            refundData.action = "canceled";
            refundData.wage_status = wage;
            refundData.reason = reason;
            isDelete = true;
        }
        else {
            isDelete = window.confirm("آیا بلیت مورد نظر استرداد شود ؟")
        }
        if (isDelete) {
            Get({ url: "/reserve/refund", data: refundData, addRes: true }).then(data => {
                if (data.status == "Success") {
                    role == "owner"
                        ? toast.success("بلیت با موفقیت لغو شد")
                        : toast.success("بلیت شما با موفقیت استرداد شد")

                    setUpdateAll(updateAll + 1)
                }
            });
        }
    }

    if (!ticketData) {
        return <></>
    }
    return (
        <div className="row mx-0 mt-4">
            <div style={{ borderBottom: "1px solid red" }} className="mb-2 col-12 mb-4">
                <h4 style={{ fontSize: "18px" }}> لیست بلیت ها </h4>
            </div>

            {role == "user" && (
                <>
                    <div className="col-12 mb-3">
                        <h5 className="mb-3">
                            <BsExclamationDiamond size={25} className="mx-2 text-warning" />
                            شرایط استرداد :
                        </h5>
                        {refundList && refundList.length > 0
                            ? (<>
                                <p className="mr-3 text-danger">
                                    استرداد قبل از آخرین زمان ثبت شده امکان پذیر است
                                </p>
                                {refundList.map(item => (
                                    <div key={item.id} className="mb-2 mr-3">
                                        <BsRecord2 className="ml-2" />
                                        میزان کسری
                                        <span className="font-weight-bold">
                                            {" " + (item.remaining_time) + " "}
                                        </span>
                                        ساعت قبل از شروع  :
                                        <span className="font-weight-bold">
                                            {" " + (item.percentage) + " "}
                                            %
                                        </span>
                                    </div>
                                ))}
                            </>)
                            : <div className="mb-2 mr-3">
                                <BsRecord2 className="ml-2" />
                                شرایطی برای استرداد ثبت نشده است
                            </div>
                        }
                    </div>
                </>
            )}

            {
                ticketData && ticketData.map((item, index) => (
                    <div key={item.id} className="col-sm-6 col-lg-4 col-xl-3 mb-2" style={{ opacity: item.status == "active" ? "1" : "0.4" }}>
                        <div className="bg-light rounded border shadow text-center p-3">
                            <span className="font-weight-bold">
                                بلیت شماره:
                                {" " + (index + 1)}
                                {" - " + (item.type == "child" ? "خردسال" : "بزرگسال")}
                            </span>

                            <p>
                                قیمت :
                                {" " + (sepJustMoney(item.price)) + " "}
                                تومان
                            </p>

                            {role == "owner"
                                ? <>
                                    <button className="btn btn-primary w-75 text-center d-flex mx-auto justify-content-center"
                                        onClick={e => {
                                            setModal({ visibleRefund: true, item_id: item.id })
                                        }}>
                                        لغو
                                    </button>
                                    {item.status != "active" && <div style={{ fontSize: "12px", marginTop: "10px" }}>
                                        {Renderststus(item.status)}
                                    </div>
                                    }
                                </>
                                : item.status == "active"
                                    ? <button className="btn btn-primary w-75 text-center d-flex mx-auto justify-content-center"
                                        onClick={e => {
                                            if (role == "manager") {
                                                appModal()
                                            }
                                            else {
                                                refundTicket(item.id)
                                            }
                                        }}>
                                        {role == "manager" && (isAbsent ? "ثبت حضور" : "منقضی کردن ")}
                                        {role == "user" && "استرداد"}
                                    </button>
                                    : <div className="btn btn-primary w-75 text-center d-flex mx-auto justify-content-center" style={{ opacity: "0.7" }}>
                                        {Renderststus(item.status)}
                                    </div>
                            }


                        </div>
                    </div>
                ))
            }

            {
                role == "owner" && (
                    <>
                        <CustomModal
                            size={"md"}
                            show={modal.visibleRefund}
                            header={"لغو بلیت"}
                            handleClose={() => {
                                setModal({ visibleRefund: false });
                            }} >
                            <div className={`mt-2 mb-3`}>
                                <TextField size="small" label="دلیل لغو" className="w-100"
                                    onChange={(e) => setReason(e.target.value)} />
                            </div>

                            <div className="d-flex align-items-center my-3">
                                <p className="mb-0 ml-2 mr-4">کسر کارمزد از  حساب مجموعه</p>
                                <FormGroup>
                                    <FormControlLabel size="sm" control={<Switch defaultChecked />} checked={wage}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setWage(true);
                                            }
                                            else {
                                                setWage(false);
                                            }
                                        }} />
                                </FormGroup>
                            </div>

                            <button className="btn btn-primary px-4"
                                onClick={() => {
                                    refundTicket(modal.item_id)
                                    setModal({ visibleRefund: false });
                                }}
                                disabled={reason ? false : true}
                            >
                                ثبت
                            </button>

                        </CustomModal>
                    </>
                )
            }

        </div >
    );
};

export default TicketList;
